import { render } from "./QuizDrawerPlayPanel.vue?vue&type=template&id=fc8dc3f4&scoped=true"
import script from "./QuizDrawerPlayPanel.vue?vue&type=script&lang=js"
export * from "./QuizDrawerPlayPanel.vue?vue&type=script&lang=js"

import "./QuizDrawerPlayPanel.vue?vue&type=style&index=0&id=fc8dc3f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8dc3f4"]])

export default __exports__